import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { DetailComparisonService } from '../services/detail-comparison.service';
import { DetailCompareDetails, Action, DetailCompareHeader } from '../objects/CompareObject';
import { WorkspaceService } from '../services/workspace.service';
import { Globals } from '../objects/Globals';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
var ComparisonComponent = /** @class */ (function () {
    function ComparisonComponent(detailComparisonService, globals, workspaceService, workflowReturnService, contextMenuService) {
        this.detailComparisonService = detailComparisonService;
        this.globals = globals;
        this.workspaceService = workspaceService;
        this.workflowReturnService = workflowReturnService;
        this.contextMenuService = contextMenuService;
        this.step = 0;
        this.isBusy = false;
        this.columnsCount = 0;
        this.paramList = [];
        this.columns = [];
        this.hiddenHeaders = [];
        this.compareActions = new EventEmitter();
        this.loadingPopup = new EventEmitter();
        this.hidePopup = new EventEmitter();
    }
    Object.defineProperty(ComparisonComponent.prototype, "setComponentId", {
        set: function (id) {
            this.componentId = id;
            this.getComparisonInfo();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComparisonComponent.prototype, "triggerAction", {
        set: function (action) {
            if (action) {
                this.compareAction(action.ActionName);
            }
        },
        enumerable: true,
        configurable: true
    });
    ComparisonComponent.prototype.ngOnInit = function () {
        document.querySelectorAll("body").item(0).style.position = "relative";
    };
    ComparisonComponent.prototype.ngOnDestroy = function () {
        document.querySelectorAll("body").item(0).style.position = "initial";
    };
    ComparisonComponent.prototype.getComparisonInfo = function () {
        var _this = this;
        this.isBusy = true;
        this.detailComparisonService.getDetailComparisonInfo(this.componentId).subscribe(function (result) {
            _this.isBusy = false;
            _this.originalCompareObject = JSON.parse(result);
            _this.columns = [];
            if (_this.originalCompareObject.Actions) {
                _this.compareActions.emit(_this.originalCompareObject.Actions);
            }
            _this.compareObject = JSON.parse(result);
            _this.formatCompareObject();
            _this.pushColumnsDropdown();
        });
    };
    ComparisonComponent.prototype.pushColumnsDropdown = function () {
        var _this = this;
        this.originalCompareObject.Headers.forEach(function (element) {
            var d = document.createElement('div');
            d.innerHTML = element.HeaderDisplay;
            var displayColm = { Order: element.Order, Name: element.Name, HeaderDisplay: d.innerText, OriginalDisplay: element.HeaderDisplay, isChecked: true };
            _this.columns.push(displayColm);
        });
    };
    ComparisonComponent.prototype.formatCompareObject = function () {
        var _this = this;
        this.sortHeader();
        this.compareObject.Headers = this.compareObject.Headers.slice(0, 4);
        ;
        var i = 0;
        this.compareObject.Headers.forEach(function (header) {
            if (_this.compareObject.Headers.length + 1 == 5) {
                _this.columnsCount = 5;
            }
            else {
                _this.columnsCount = 12 / (_this.compareObject.Headers.length + 1);
            }
        });
    };
    ComparisonComponent.prototype.setStep = function (index, groupName) {
        var _this = this;
        this.step = index;
        this.isBusy = false;
        if (!this.compareObject.Groups.find(function (x) { return x.Name == groupName; }).Data) {
            this.detailComparisonService.getDetailComparisonGroup(this.componentId, groupName).subscribe(function (result) {
                _this.compareObject.Groups.find(function (x) { return x.Name == groupName; }).Data = JSON.parse(result);
                //console.log(this.compareObject);
            });
        }
    };
    ComparisonComponent.prototype.nextStep = function () {
        this.step++;
    };
    ComparisonComponent.prototype.prevStep = function () {
        this.step--;
    };
    ComparisonComponent.prototype.getVisiblePrevious = function (header, first) {
        if (first && this.compareObject.Headers.length > 3) {
            var index = this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == header.Name; });
            if (index > -1 && this.originalCompareObject.Headers[index - 1]) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    ComparisonComponent.prototype.getVisibleNext = function (header, last) {
        if (last && this.compareObject.Headers.length > 3) {
            var index = this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == header.Name; });
            if (index > -1 && this.originalCompareObject.Headers[index + 1]) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    ComparisonComponent.prototype.nextItem = function () {
        var lastName = this.compareObject.Headers[this.compareObject.Headers.length - 1].Name;
        var lastIndex = this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == lastName; });
        if (this.originalCompareObject.Headers[lastIndex + 1]) {
            this.compareObject.Headers.shift();
            this.compareObject.Headers.push(this.originalCompareObject.Headers[lastIndex + 1]);
        }
    };
    ComparisonComponent.prototype.previousItem = function () {
        var firstName = this.compareObject.Headers[0].Name;
        var firstIndex = this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == firstName; });
        if (this.originalCompareObject.Headers[firstIndex - 1]) {
            this.compareObject.Headers.splice(-1, 1);
            this.compareObject.Headers.unshift(this.originalCompareObject.Headers[firstIndex - 1]);
        }
    };
    ComparisonComponent.prototype.onValueChange = function (groupName, propertyDisplay, headerName, value) {
        var param;
        // construct object to prepare for workflow parameter => it is a list of headers, which has a list of all its changed properties 
        if (this.paramList.find(function (x) { return x.name == headerName; })) {
            var existingParam = this.paramList.find(function (x) { return x.name == headerName; });
            if (this.originalCompareObject.Groups.find(function (x) { return x.Name == groupName; }).Type == "SUBDOC") {
                param = { name: propertyDisplay, value: value, group: groupName };
            }
            else {
                param = { name: propertyDisplay, value: value };
            }
            var exists = existingParam.value.findIndex(function (z) { return z.name == propertyDisplay; });
            if (exists > -1) {
                existingParam.value.splice(exists, 1, param);
            }
            else {
                existingParam.value.push(param);
            }
        }
        else {
            var headerArray = [];
            var header;
            header = { name: "DocumentInstanceId", value: headerName }; // this is the identifier for each header, headerName == header id
            if (this.originalCompareObject.Groups.find(function (x) { return x.Name == groupName; }).Type == "SUBDOC") {
                param = { name: propertyDisplay, value: value, group: groupName };
            }
            else {
                param = { name: propertyDisplay, value: value };
            }
            headerArray.push(header);
            headerArray.push(param);
            this.paramList.push({ name: headerName, value: headerArray }); // so param list will contains all the list of header arrays
        }
        //console.log(headerArray);
        //console.log(this.paramList);
        this.detailComparisonService.detailComparisonUpdateValue(this.componentId, groupName, headerName, param).subscribe(function (result) {
            console.log(result);
        });
    };
    ComparisonComponent.prototype.compareAction = function (actionName) {
        var _this = this;
        this.loadingPopup.emit(true);
        var arr = [];
        this.originalCompareObject.Headers.forEach(function (header) {
            if (!header.Name.startsWith("#")) {
                arr.push({ name: 'Name', value: header.Name });
            }
        });
        this.detailComparisonService.detailComparisonAction(this.componentId, actionName, arr).subscribe(function (result) {
            _this.loadingPopup.emit(false);
            if (result) {
                var wf = JSON.parse(result);
                _this.workflowReturnService.handleWorkflowReturn(wf);
                switch (wf.RefreshType) {
                    case "self":
                        _this.getComparisonInfo();
                        break;
                    case "parent":
                        _this.isBusy = true;
                        _this.getComparisonInfo();
                        _this.getEPICParent(false, wf.ReturnType);
                        break;
                    case "all":
                        _this.getComparisonInfo();
                        _this.getEPICParent(true, wf.ReturnType);
                        break;
                }
            }
        }, function (error) {
            _this.loadingPopup.emit(false);
        });
    };
    ComparisonComponent.prototype.getEPICParent = function (findAllParent, returnType) {
        var _this = this;
        if (findAllParent) {
            this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(function (result) {
                _this.handlePopup(returnType);
                if (result) {
                    var array = JSON.parse(result);
                    array.forEach(function (id) {
                        _this.workspaceService.setParentId(id);
                    });
                }
            }, function (error) {
                _this.handlePopup(returnType);
            });
        }
        else {
            this.workspaceService.getParentEPICId(this.componentId).subscribe(function (result) {
                _this.workspaceService.setParentId(result);
                _this.handlePopup(returnType);
            }, function (error) {
                _this.handlePopup(returnType);
            });
        }
    };
    ComparisonComponent.prototype.handlePopup = function (returnType, isPreview) {
        if (isPreview === void 0) { isPreview = false; }
        if (returnType == 4) {
            this.hidePopup.emit(true);
        }
    };
    ComparisonComponent.prototype.onSelectionChange = function (event) {
        var _this = this;
        this.loadingPopup.emit(true);
        this.detailComparisonService.getFileCompareObject(this.componentId, this.originalCompareObject.CompareDefinition, encodeURIComponent(event.SelectionValue), this.originalCompareObject.ComparingIds).subscribe(function (result) {
            if (result) {
                var command = JSON.parse(result);
                _this.workflowReturnService.handleWorkflowReturn(JSON.parse(result));
                switch (command.RefreshType) {
                    case "self":
                        _this.getComparisonInfo();
                        break;
                }
            }
            _this.loadingPopup.emit(false);
        }, function (error) {
            _this.loadingPopup.emit(false);
        });
    };
    ComparisonComponent.prototype.drop = function (event) {
        var _this = this;
        if (event) {
            if (event.value) {
                if (event.value.Order) {
                    var header = this.compareObject.Headers.find(function (x) { return x.Name == event.value.Name; }); // drag element
                    if (header) {
                        var originalOrder = header.Order;
                        if (this.compareObject.Headers[event.dropIndex - 1]) {
                            var newOrder = this.compareObject.Headers[event.dropIndex - 1].Order;
                            this.compareObject.Headers[event.dropIndex - 1].Order = originalOrder;
                            if (this.originalCompareObject.Headers.find(function (x) { return x.Name == _this.compareObject.Headers[event.dropIndex - 1].Name; })) {
                                this.originalCompareObject.Headers.find(function (x) { return x.Name == _this.compareObject.Headers[event.dropIndex - 1].Name; }).Order = originalOrder;
                            }
                            header.Order = newOrder;
                            this.originalCompareObject.Headers.find(function (x) { return x.Name == event.value.Name; }).Order = newOrder;
                        }
                        this.sortHeader();
                        this.sortOriginalHeader();
                        this.originalCompareObject = Object.assign({}, this.originalCompareObject);
                        this.compareObject = Object.assign({}, this.compareObject);
                    }
                }
            }
        }
    };
    ComparisonComponent.prototype.sortHeader = function () {
        this.compareObject.Headers = this.compareObject.Headers.sort(function (a, b) {
            if (a.Order > b.Order) {
                return 1;
            }
            else if (a.Order < b.Order) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    ComparisonComponent.prototype.sortOriginalHeader = function () {
        this.originalCompareObject.Headers = this.originalCompareObject.Headers.sort(function (a, b) {
            if (a.Order > b.Order) {
                return 1;
            }
            else if (a.Order < b.Order) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    ComparisonComponent.prototype.onContextMenu = function ($event) {
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                anchorElement: $event.target,
                contextMenu: this.basicMenu,
                event: $event,
                item: ''
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    ComparisonComponent.prototype.onChange = function (event) {
        var _this = this;
        if (!event.isChecked) {
            var visible = true;
            var header = this.compareObject.Headers.find(function (x) { return x.Name == event.Name; }); // find in visible headers
            if (!header) {
                header = this.originalCompareObject.Headers.find(function (x) { return x.Name == event.Name; }); // find in original headers
                visible = false;
            }
            header["isVisible"] = visible; // this is to know where its from, either from the visible headers, or the original list
            this.hiddenHeaders.push(header);
            if (visible) {
                if (this.compareObject.Headers.length == 4) {
                    var nextHeader = this.originalCompareObject.Headers[this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == _this.compareObject.Headers[_this.compareObject.Headers.length - 1].Name; }) + 1];
                    if (!nextHeader) {
                        nextHeader = this.originalCompareObject.Headers[this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == _this.compareObject.Headers[0].Name; }) - 1];
                    }
                    if (nextHeader) {
                        this.compareObject.Headers.push(nextHeader);
                    }
                }
                this.compareObject.Headers.splice(this.compareObject.Headers.findIndex(function (x) { return x.Name == event.Name; }), 1);
                this.originalCompareObject.Headers.splice(this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == event.Name; }), 1);
            }
            else {
                this.originalCompareObject.Headers.splice(this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == event.Name; }), 1);
            }
        }
        else {
            var newObj = {
                Order: event.Order,
                Name: event.Name,
                HeaderDisplay: event.OriginalDisplay
            };
            var isVisible = this.hiddenHeaders.find(function (x) { return x.Name == event.Name; }).isVisible;
            this.hiddenHeaders.splice(this.hiddenHeaders.findIndex(function (x) { return x.Name == event.Name; }), 1);
            if (isVisible) {
                this.compareObject.Headers.push(newObj);
            }
            else {
                if (this.compareObject.Headers.findIndex(function (x) { return x.Name == event.Name; }) == -1 && this.compareObject.Headers.length < 4) {
                    this.compareObject.Headers.push(newObj);
                }
            }
            var g = this.originalCompareObject.Headers.find(function (x) { return x.Name == newObj.Name; });
            if (!g) {
                this.originalCompareObject.Headers.push(newObj);
            }
        }
        this.formatCompareObject();
        this.sortOriginalHeader();
        this.originalCompareObject = Object.assign({}, this.originalCompareObject);
        this.compareObject = Object.assign({}, this.compareObject);
    };
    return ComparisonComponent;
}());
export { ComparisonComponent };
